import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';

const serialize = (data) => ({
  list: data?.results?.map((item: string) => item?.toLowerCase()),
  oemPayload: data?.fallback_results_payload,
});

export const fetchServiceableCities = async () => {
  const url = `${apiConfig('oem')}/v2/oem/leads/serviceable`;

  const { response, error } = await getMethod({ endPoint: url });

  if (response) {
    if (response?.data?.results) {
      return serialize(response.data);
    }
  }
  return null;
};
